import * as React from 'react';
const SvgYoutube = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>
        <path
            fill='currentColor'
            d='M15.057 5.019c1.353 0 2.443 1.197 2.443 2.669v4.774c.006 1.478-1.09 2.669-2.443 2.669H4.943c-1.353 0-2.443-1.197-2.443-2.67V7.689c0-1.478 1.096-2.67 2.443-2.67zm-6.06 6.96 3.247-2.087-3.248-2.088z'
        />
    </svg>
);
export default SvgYoutube;
